import React from 'react';
import TenantSignupComponent from '../components/tenant/Signup';

const TenantSignup: React.FC = () => {
  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-main-dark p-5">
      <TenantSignupComponent />
    </div>
  );
};

export default TenantSignup;
